// A federation game on a club's calendar: the event's own colour under diagonal stripes, so it
// reads as someone else's (read-only) on any event colour.
const PAIRED_EVENT_STRIPES =
  'repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.35) 0, rgba(255, 255, 255, 0.35) 6px, transparent 6px, transparent 12px)'

export const PAIRED_EVENT_CLASS = 'paired-event'

export default PAIRED_EVENT_STRIPES
